import { render } from "./prodocutlist.vue?vue&type=template&id=023f12aa"
import script from "./prodocutlist.vue?vue&type=script&lang=js"
export * from "./prodocutlist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__